<template>
  <header class="height40 common">
    <el-popover
      ref="messageBox"
      placement="bottom"
      width="350"
      trigger="click"
      v-model="messageVisible"
      :disabled="!unreadMessageInfo.totalCount">
      <div class="message-box">
        <p class="mc-title">消息中心</p>
        <ul>
          <li v-for="message in unreadMessageInfo.data">
            <a href="javascript:void(0);" class="message-title"
               @click="handleShowDetail(message)">{{message.title.length > 23 ? message.title.slice(0, 22) + '...' :
              message.title
              }}</a>
            <img :src="icon_new" alt="mew" class="message-icon">
            <span class="message-time">{{message.publish_time}}</span>
          </li>
        </ul>
        <p class="mc-footer" @click="handleShowMoreMessages">查看更多</p>
      </div>
    </el-popover>

    <img :src="logoUrl" alt="" class="nav-logo">
    <div class="sep"></div>
    <div class="restaurant">
      {{userInfo.agencyName}}
    </div>
    <ul class="account-area">
      <li class="message" v-popover:messageBox @click="handleGoMsgCenter">
        消息
        <span class="message-count" v-show="unreadMessageInfo.totalCount">{{unreadMessageInfo.totalCount}}</span>
      </li>
      <li class="x-line"></li>
      <li>
        <div class="username">
          <el-dropdown @command="handleCommand" trigger="click">
            <span class="el-dropdown-link">
              欢迎你，{{userInfo.realName}}
              <img v-if="userInfo.weekPassword" class="guide-pwd" :src="guide_pwd_02" />
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changePwd">
                修改密码
                <img v-if="userInfo.weekPassword" class="guide-pwd" :src="guide_pwd_01" style="width: 14px;height: 14px;"/>
              </el-dropdown-item>
              <el-dropdown-item>退出系统</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </li>
    </ul>
    <el-dialog title="修改密码" :visible.sync="visible">
      <el-form :model="passwordForm" :rules="rule" label-width="100px" ref="form" class="password-info-dialog">
        <div class="guide-tip" v-if="userInfo.weekPassword"><span class="weak-warn">* 温馨提示：</span>您的密码强度较弱，存在被盗风险，建议您更改密码以保护账户安全。</div>
        <el-form-item label="用户名：">
          <span>{{this.userInfo.userName}}</span>
        </el-form-item>
        <el-form-item label="旧密码：" prop="password">
          <el-input type="password" v-model="passwordForm.password" :maxlength="16"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPwd">
          <el-input type="password" v-model="passwordForm.newPwd" :minlength="6" :maxlength="16"></el-input>
          <p class="tips">6-16位，由字母、数字、符号至少两种组成，区分大小写</p>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirmPwd">
          <el-input type="password" v-model="passwordForm.confirmPwd" :maxlength="16"></el-input>
        </el-form-item>
        <div class="footer-btns">
          <el-button type="primary" @click="handleChgPwd">保存</el-button>
          <el-button @click="visible=false">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <message-dialog ref="m_dialog" @close="handleCloseDialog"></message-dialog>
  </header>
</template>

<script>
  import logoUrl from '@assets/images/logo.png';
  import icon_new from '@assets/images/icon-new.png';
  import MessageDialog from '@ui/MessageNav/MessageDialog.vue';
  import {mapState, mapActions} from 'vuex';
  import getUnreadMessageInfo from '@util/getUnreadMessageInfo';
  import guide_pwd_01 from '@assets/images/guide-pwd-01.png';
  import guide_pwd_02 from '@assets/images/guide-pwd-02.png';

  export default {
    data () {
      let checkPassword = (rule, value, callback) => {
        if (!value.trim()) {
          return callback(new Error('请输入密码'));
        } else if (value.length < 6 || value.length > 16) {
          callback(new Error('密码长度6-16位！'));
        } else if ( !/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*.?\s]+)$)^[\w~!@#$%^&*.?\s]{6,16}$/.test(value)) {
          return callback(new Error('6-16位，由字母、数字、符号至少两种组成，区分大小写'));
        } else if (this.userInfo.userName
          && ( value.indexOf(this.userInfo.userName) === 0
          || (value.indexOf(this.userInfo.userName) === value.length - this.userInfo.userName.length && value.indexOf(this.userInfo.userName) > 0)) ) {
          return callback(new Error('密码头部或尾部不能包含用户名'));
        } else {
          callback();
        }
      };
      let checkConfirmPassword = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请再次输入密码'));
        } else if (value !== this.passwordForm.newPwd) {
          return callback(new Error('两次输入密码不一致'));
        } else {
          callback();
        }
      };
      return {
        logoUrl,
        icon_new,
        guide_pwd_01,
        guide_pwd_02,
        visible: false,
        passwordForm: {
          password: '',
          newPwd: '',
          confirmPwd: ''
        },
        rule: {
          password: [
            {required: true, message: '请输入登录密码', trigger: 'blur'}
          ],
          newPwd: [
            {required: true, validator: checkPassword, trigger: 'blur'}
          ],
          confirmPwd: [
            {required: true, validator: checkConfirmPassword, trigger: 'blur'}
          ]
        },
        messageVisible: false,
        unreadMessageInfo: {
          totalCount: 0,
          data: []
        },
        urgentTimer: null,
      };
    },
    created () {
      getUnreadMessageInfo(true);
      this.getUserAndHotelInfo();
      if (this.userInfo.weekPassword && !localStorage.getItem('weakPwd')) {
        this.visible = true;
        localStorage.setItem('weakPwd', 'true');
      }
    },
    mounted () {
      this.$nextTick(()=>{
        global.vm.$on('refresh_message', (res) => {
          console.log(res);

          this.unreadMessageInfo = {
            totalCount: res.total,
            data: res.list
          };
        });
      });

      clearInterval(this.urgentTimer);
      this.urgentTimer = setInterval(this.getUrgentMessage(), 10*60*1000);
    },
    computed: {
      ...mapState(['userInfo'])
    },
    methods: {
      ...mapActions(['getUserAndHotelInfo']),
      handleShowMoreMessages () {
        this.messageVisible = false;
        let path = '/MessageCenter';
        if (this.$route.path === path) {
          // 转到中间件来强制刷新当前 router-view
          this.$router.replace({
            path: '/Midware',
            query: {
              targetUrl: path
            }
          });
        } else {
          this.$router.push({
            path: path
          });
        }
      },
      handleGoMsgCenter () {
        if (this.unreadMessageInfo.totalCount === 0) {
          this.handleShowMoreMessages();
        }
      },
      getUrgentMessage () {
        let _this = this;
        // 10分钟内没有其他ajax请求则不处理本请求（防止session不失效）
        // 排除本身请求的影响，但考虑不在拦截器做太多业务判断，所以这里判断改成9分钟
        if (+new Date() - window.previousAjaxTimeStamp > 9*60*1000) {
          return;
        }
        _this.$axios.post('/irs-api/ces-web/user/api/v3/message/notifyMessage', this.$qs.stringify({platform: 'HQ', pushType: 2})).then((res) => {
          let response = res.data;
          if (response && response.is_read === 0) {
            _this.$refs.m_dialog.show(response.id, 0, 2);
          }
        });
        return _this.getUrgentMessage;
      },
      handleShowDetail (message) {
        this.$refs.m_dialog.show(message.id, 0, false);
      },
      handleChgPwd () {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$axios.post('/hq-web/profile', this.$qs.stringify(this.passwordForm)).then((res) => {
              if (res.success) {
                this.getUserAndHotelInfo();
                if (top.vm) {
                  let guidePwd = top.vm.$el.parentElement.querySelectorAll('.guide-pwd');
                  if (guidePwd && guidePwd.length >= 2) {
                    guidePwd[0].style.display = 'none';
                    guidePwd[1].style.display = 'none';
                  }
                } else {
                  if (top.$('.guide-pwd') && top.$('.guide-pwd').length > 0) {
                    top.$('.guide-pwd').css({display: 'none'});
                  }
                }
                localStorage.removeItem('weakPwd');
                this.$message.success('密码修改成功');
                this.visible = false;
              } else {
                this.$message.error(res.errorInfo);
              }
            });
          }
        });
      },
      handleCommand (command) {
        if (command === 'changePwd') {
          this.visible = true;
          this.passwordForm = {
            password: '',
            newPwd: '',
            confirmPwd: ''
          };
          this.$nextTick(() => {
            this.$refs.form.resetFields();
          });
        } else {
          localStorage.removeItem('menu');
          localStorage.removeItem('menuList');
          window.location.href = "/hq-web/logout";
        }
      },
      handleCloseDialog: function () {
        getUnreadMessageInfo(true);
      },
    },
    components: {
      'message-dialog': MessageDialog
    }
  };
</script>

<style lang="less">
  header.common {
    top: 0;
    left: 0;
    width: 100%;
    line-height: 60px;
    background: #016cdf;
    z-index: 2;
    .password-info-dialog {
      width: 80%;
      margin-left: 10%;
      .footer-btns {
        text-align: center;
      }
      .tips {
        font-size: 12px;
        color: #999999;
        width: 360px;
      }
      .guide-tip {
        margin-left: -88px;
        margin-bottom: 20px;
        font-size: 14px;

        .weak-warn {
          color: red;
        }
      }
    }
    .guide-pwd {
      margin: 0;
      width: 14px;
      height: 14px;
    }
    .height40 {
      height: 40px;
      line-height: 40px;
      padding-left: 10px;
      .system-item {
        display: inline-block;
        font-size: 18px;
        opacity: 0.5;
        width: 160px;
        text-align: center;
        cursor: pointer;
        &.active {
          opacity: 1;
          border-bottom: 3px solid #fff;
        }
        a {
          color: #fff;
        }
      }
    }

    .nav-logo {
      width: 140px;
    }

    .account-area {
      position: fixed;
      top: 0;
      right: 0;
      padding-right: 30px;
      margin: 0;
      cursor: pointer;

      li {
        float: left;
        top: 0;
        right: 0;
        zoom: 1;
        filter: alpha(opacity=100);
        opacity: 1;
        list-style: none;
        margin-bottom: 0;
        display: inline-block;
      }
      .x-line {
        border: 1px solid white;
        width: 0;
        height: 18px;
        opacity: 0.5;
        margin: 20px 15px;
      }
    }

    .message {
      font-size: 14px;
      color: #e5f0fb;

      .message-count {
        display: inline-block;
        min-width: 10px;
        height: 20px;
        line-height: 20px;
        background: #E94B3B;
        text-align: center;
        border-radius: 10px;
        font-size: 14px;
        transform: scale(0.8, 0.8);
        margin-left: -4px;
        padding: 0 6px 0 4px;
      }
    }

    img {
      margin: 10px 17px 13px 19px;
    }

    .sep {
      border: 1px solid white;
      width: 0;
      height: 18px;
      position: absolute;
      top: 21px;
      left: 175px;
      opacity: 0.5;
      margin: 0 10px;
    }

    .service {
      position: absolute;
      top: 0;
      left: 193px;
      font-size: 18px;
      color: #fff;
      letter-spacing: -0.44px;
    }

    .restaurant {
      position: absolute;
      top: 0;
      left: 215px;
      font-size: 18px;
      color: #fff;
      letter-spacing: -.44px;
    }

    .username {
      top: 0;
      right: 19px;
    }

    .el-dropdown-link {
      color: #E5F0FB;
      font-size: 14px;
      letter-spacing: -0.44px;
    }

    .el-icon-caret-bottom:before {
      width: 8px;
      height: 5px;
    }

    .el-icon--right {
      margin-left: 0;
    }
  }

  .message-popover {
    background: #ffffff;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.50);
    border-radius: 3px;
    margin-top: -10px !important;
    .message-box {
      .mc-title {
        font-size: 12px;
        font-weight: bold;
        color: #333;
        text-align: center;
        border-bottom: 2px solid #016cdf;
        padding: 12px 0;
        margin: 0;
      }
      ul {
        padding-left: 18px;
      }
      li {
        border-bottom: 1px solid #dedede;
        padding: 6px 0;
        line-height: 20px;
        .message-title {
          color: #333;
          text-decoration: none;
        }
        .message-icon {
          float: right;
          margin-right: 20px;
          width: 26px;
        }
        .message-time {
          color: #9b9b9b;
          display: block;
        }
      }
      .mc-footer {
        color: #016cdf;
        text-align: center;
        cursor: pointer;
        padding: 10px 0;
      }
    }
  }

  .el-popover {
    background: #ffffff;
    margin-top: 2px !important;
    .message-box {
      .mc-title {
        font-size: 12px;
        font-weight: bold;
        color: #333;
        text-align: center;
        border-bottom: 2px solid #016cdf;
        padding: 12px 0;
        margin: 0;
      }
      ul {
        padding-left: 18px;
      }
      li {
        border-bottom: 1px solid #dedede;
        padding: 6px 0;
        line-height: 20px;
        .message-title {
          color: #333;
          text-decoration: none;
        }
        .message-icon {
          float: right;
          margin-right: 20px;
          width: 26px;
        }
        .message-time {
          color: #9b9b9b;
          display: block;
        }
      }
      .mc-footer {
        color: #016cdf;
        text-align: center;
        cursor: pointer;
        padding: 10px 0;
      }
    }
  }

  .user-info-wrap {
    .el-dialog__body {
      padding-top: 0;
    }

  }

</style>



// WEBPACK FOOTER //
// NavBar.vue?57093694